"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var adjustUrlParams_1 = __importDefault(require("./adjustUrlParams"));
var isEmptyString_1 = __importDefault(require("./utils/isEmptyString"));
var sanitize = function (params, onlyTruthyParams) {
    return onlyTruthyParams ? lodash_1.omitBy(params, isEmptyString_1.default) : params;
};
/**
 * Takes an object and adds it as a query string to the given URL.
 * If there is already a query string with the URL, append the given
 * params to the query string.
 *
 * Optionally, filters out falsy params with `onlyTruthParams`
 */
var addParamsToUrl = function (url, params, onlyTruthyParams) {
    if (url === void 0) { url = ''; }
    if (params === void 0) { params = {}; }
    if (onlyTruthyParams === void 0) { onlyTruthyParams = false; }
    return adjustUrlParams_1.default(function (currentParams) { return (__assign(__assign({}, currentParams), sanitize(params, onlyTruthyParams))); }, url);
};
exports.default = addParamsToUrl;
